import type { RouteRecordRaw } from 'vue-router';
export const posRoutes: RouteRecordRaw[] = [
  { path: 'pos', name: 'pos', component: () => import('../pages/pos/PosPage.vue'), meta: { requiresModule: 'pos' } },
];
